<template>
    <div class="reports">
        <v-row class="dashboard-title m-0 pb-2">
            <v-col cols="12" lg="8" class="actions left">
                <v-select
                    v-model="chartMenu"
                    :items="chartMenuItems"
                    :clearable="chartMenu !== 'week'"
                    rounded
                    outlined
                    dense
                    append-icon="mdi-chevron-down"
                    @input="selectPeriod"
                    @click:clear="clearPeriod"
                >
                </v-select>
                <span class="repors-period">{{ selectedPeriodString }}</span>
            </v-col>
            <v-col v-if="can('trackers.index')" cols="12" lg="4" class="actions right">
                <v-btn color="primary" small rounded @click="goTo('trackers.index')"
                    >{{ t('menu::trackers') }}
                    <v-icon right>mdi-chevron-right</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <report-summary-component
            v-if="can('api.v1.reports.patients-stats') && reports && reports.reportSummary"
            :summary="reports.reportSummary"
            @setDataTableFromSummary="setDataTable"
        ></report-summary-component>

        <report-charts-component
            v-if="can('api.v1.reports.charts-data') && reports.reportChartData.data"
            :chart-data="reports.reportChartData"
            @setDataTable="setDataTable"
        ></report-charts-component>
        <div class="reprots-tabs">
            <v-tabs-items
                v-model="tab"
                class="py-0"
                transition="scroll-x-reverse-transition"
                reverse-transition="scroll-x-transition"
                touchless
            >
                <v-tab-item v-for="(item, index) in tabsItems" :key="index">
                    <v-col cols="12">
                        <component
                            :is="item.component"
                            v-if="item.component === 'report-data-table-component'"
                            :endpoint="item.endPoint !== 'all-patients' ? item.endPoint : tabsItems[0].endPoint"
                        ></component>
                        <component
                            :is="item.component"
                            v-if="item.component === 'report-patients-data-table-component'"
                            :list-route="item.endPoint"
                        ></component>
                    </v-col>
                </v-tab-item>
                <!-- <v-tab-item v-for="endpoint in reportsEndPoints" :key="endpoint">
                    <v-col cols="12">
                        <report-data-table-component
                            :endpoint="endpoint !== 'all-patients' ? endpoint : reportsEndPoints.all_patients"
                        ></report-data-table-component>
                    </v-col>
                </v-tab-item> -->
            </v-tabs-items>
        </div>

        <v-dialog
            ref="dialog"
            v-model="customPeriodDialog"
            :return-value.sync="customPeriodDates"
            persistent
            width="290px"
            class="reports-dialog"
            @input="closePeriodDialog($event)"
        >
            <v-date-picker
                v-model="customPeriodDates"
                class="reports-date-picker"
                scrollable
                range
                :title-date-format="(val) => selectedText(val)"
            >
                <v-btn text color="primary" rounded @click="closeCustomDateModal">
                    {{ t('reports::button.close') }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    rounded
                    :disabled="!(customPeriodDates && customPeriodDates.length > 1)"
                    @click="$refs.dialog.save(customPeriodDates)"
                >
                    {{ t('reports::button.apply') }}
                </v-btn>
            </v-date-picker>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'Reports',
    components: {},
    props: {
        listRoute: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            tab: 0,
            chartExtended: false,
            chartMenu: 'week',
            customPeriodDialog: false,
            customPeriodDates: null,
            selectedPeriod: { text: t('reports::labels.week'), value: 'week' },
            selectedPeriodRange: '',
            chartMenuItems: [
                { text: t('reports::labels.week'), value: 'week' },
                { text: t('reports::labels.month'), value: 'month' },
                { text: t('reports::labels.custom'), value: 'custom' },
            ],
            reportsEndPoints: {
                all_patients: 'all-patients',
                red_patients: 'red-patients',
                amber_patients: 'amber-patients',
            },
            reportEndPoint: null,
            reportGridData: null,
            tablePeriod: {},
            selectedPeriodValues: {},
            tabsItems: [
                { component: 'report-data-table-component', endPoint: 'all-patients' },
                { component: 'report-data-table-component', endPoint: 'red-patients' },
                { component: 'report-data-table-component', endPoint: 'amber-patients' },
                {
                    component: 'report-patients-data-table-component',
                    endPoint: route('api.v1.patients.index'),
                },
            ],
            selectedReportType: null,
        };
    },
    computed: {
        reports() {
            return this.$store.state.reports;
        },
        gridTitle: {
            get() {
                return this.$store.state.reports.gridTitle;
            },
            set(title) {
                return this.$store.dispatch('reports/setGridTitle', title);
            },
        },
        selectedPeriodString() {
            return this.$store.state.reports.selectedPeriodString;
        },
        selectedPeriods() {
            return this.$store.state.reports.reportChartData.meta;
        },
        selectedPeriodFilter() {
            return this.$store.state.reports.selectedPeriod;
        },
    },
    watch: {
        customPeriodDates: function (newValue, oldValue) {
            if (!newValue) return;
            if (newValue !== oldValue && newValue.length > 1) {
                if (moment(newValue[0]).isAfter(moment(newValue[1])) || newValue[0] === newValue[1]) {
                    this.selectedPeriodRange = `${moment(newValue[1]).format('ll')} - ${moment(newValue[0]).format(
                        'll'
                    )}`;
                }
                if (moment(newValue[1]).isAfter(moment(newValue[0]))) {
                    this.selectedPeriodRange = `${moment(newValue[0]).format('ll')} - ${moment(newValue[1]).format(
                        'll'
                    )}`;
                }
            }
        },
        selectedPeriodValues: function (newValue, oldValue) {
            if (newValue !== oldValue) {
                this.$store.dispatch('reports/setReportsPeriod', newValue);
            }
        },
    },
    created() {
        this.$store.dispatch('reports/fetchReportsSummary');
        this.$store.dispatch(
            'reports/setGridTitle',
            `${t('reports::grid.title.blood_results')} <small>${t('reports::grid.title.all_patients')}</small>`
        );
        this.fetchReportsChartData();
        this.reportEndPoint = this.reportEndPoint ? this.reportEndPoint : this.reportsEndPoints.all_patients;

        this.tablePeriod = {
            start_date:
                this.customPeriodDates && this.customPeriodDates.length
                    ? this.customPeriodDates[0]
                    : moment(new Date()).format('Y-MM-DD'),
            end_date:
                this.customPeriodDates && this.customPeriodDates.length
                    ? this.customPeriodDates[1]
                    : moment(new Date().setDate(new Date().getDate() + 1)).format('Y-MM-DD'),
            period: this.selectedPeriod.value,
        };
        this.selectedPeriodValues = this.tablePeriod;
    },
    mounted() {},
    methods: {
        clearPeriod() {
            this.customPeriodDates = null;
        },
        closeCustomDateModal() {
            this.chartMenu = this.chartMenuItems[0].value;
            this.selectedPeriod = this.chartMenuItems[0];
            this.customPeriodDialog = false;
            this.selectPeriod(this.chartMenu);
        },
        fetchReportsChartData(params = null) {
            this.$store.dispatch(
                'reports/fetchReportsChartData',
                params ? params : { period: this.selectedPeriod.value }
            );
        },
        setDataTable(reportType) {
            if (reportType === this.selectedReportType) {
                return;
            }
            this.selectedReportType = reportType;

            let period = { period: 'day' };
            switch (this.selectedPeriodFilter.period) {
                case 'day':
                    period = { period: 'day' };
                    break;
                case 'week':
                    period = { period: 'week' };
                    break;
                case 'month':
                    period = { period: 'month' };
                    break;
                case 'custom':
                    period = _.clone(this.selectedPeriodFilter);
                    delete period.period;
                    break;
                default:
                    period = { period: 'day' };
                    break;
            }
            switch (reportType) {
                case 'all-patients':
                    this.tab = 0;
                    this.gridTitle = `${t('reports::grid.title.blood_results')} <small>${t(
                        'reports::grid.title.adverse_events'
                    )}</small>`;
                    this.$store.dispatch('reports/setPatientsGridFilters', {
                        report_type: 'all-patients',
                        ...period,
                    });
                    break;
                case 'red-patients':
                    this.tab = 1;
                    this.gridTitle = `${t('reports::grid.title.blood_results')} <small>${t(
                        'reports::grid.title.red_types'
                    )}</small>`;
                    this.$store.dispatch('reports/setPatientsGridFilters', {
                        report_type: 'red-patients',
                        ...period,
                    });
                    break;
                case 'amber-patients':
                    this.tab = 2;
                    this.gridTitle = `${t('reports::grid.title.blood_results')} <small>${t(
                        'reports::grid.title.amber_types'
                    )}</small>`;
                    this.$store.dispatch('reports/setPatientsGridFilters', {
                        report_type: 'amber-patients',
                        ...period,
                    });
                    break;
                case 'overdue':
                    this.tab = 3;
                    this.gridTitle = `${t('patients::page.title.patients')} <small>${t(
                        'reports::grid.title.overdue'
                    )}</small>`;
                    this.$store.dispatch('reports/setPatientsGridFilters', {
                        report_type: 'overdue',
                        ...period,
                    });
                    break;
                case 'max_dispensing':
                    this.tab = 3;
                    this.gridTitle = `${t('patients::page.title.patients')} <small>${t(
                        'reports::grid.title.max_dispensing'
                    )}</small>`;
                    this.$store.dispatch('reports/setPatientsGridFilters', {
                        report_type: 'max_dispensing',
                        ...period,
                    });
                    break;
                case 'due_for_the_week':
                    this.tab = 3;
                    this.gridTitle = `${t('patients::page.title.patients')} <small>${t(
                        'reports::grid.title.due_for_the_week'
                    )}</small>`;
                    this.$store.dispatch('reports/setPatientsGridFilters', {
                        report_type: 'due_for_the_week',
                        next_due_date: [
                            moment().startOf('isoWeek').format('YYYY-MM-DD'),
                            moment().endOf('isoWeek').format('YYYY-MM-DD'),
                        ],
                        ...period,
                    });
                    break;
                case 'newly_registered':
                    this.tab = 3;
                    this.gridTitle = `${t('patients::page.title.patients')} <small>${t(
                        'reports::grid.title.newly_registered'
                    )}</small>`;
                    this.$store.dispatch('reports/setPatientsGridFilters', {
                        report_type: 'newly_registered',
                        ...period,
                    });
                    break;
                case 'newly_restarted':
                    this.tab = 3;
                    this.gridTitle = `${t('patients::page.title.patients')} <small>${t(
                        'reports::grid.title.newly_restarted'
                    )}</small>`;
                    this.$store.dispatch('reports/setPatientsGridFilters', {
                        report_type: 'newly_restarted',
                        ...period,
                    });
                    break;
                case 'newly_transferred':
                    this.tab = 3;
                    this.gridTitle = `${t('patients::page.title.patients')} <small>${t(
                        'reports::grid.title.newly_transferred'
                    )}</small>`;
                    this.$store.dispatch('reports/setPatientsGridFilters', {
                        report_type: 'newly_transferred',
                        ...period,
                    });
                    break;
                case 'newly_re_challenged':
                    this.tab = 3;
                    this.gridTitle = `${t('patients::page.title.patients')} <small>${t(
                        'reports::grid.title.newly_re_challenged'
                    )}</small>`;
                    this.$store.dispatch('reports/setPatientsGridFilters', {
                        report_type: 'newly_re_challenged',
                        ...period,
                    });
                    break;
                case 'all_patients':
                    this.tab = 3;
                    this.gridTitle = `${t('patients::page.title.patients')} <small>${t(
                        'reports::grid.title.all_patients'
                    )}</small>`;
                    this.$store.dispatch('reports/setPatientsGridFilters', {
                        report_type: 'all_patients',
                    });
                    break;
                default:
                    break;
            }
        },
        editItemUrl(item) {
            return route('patients.get', {
                patient: item.patient.id,
                load_lood_result: true,
                blood_result_id: item.id,
            });
        },
        goTo(link) {
            window.location.href = route(link) ? route(link) : false;
        },
        selectPeriod(item) {
            const prefixes = [
                'all_patients',
                'due_for_the_week',
                'newly_registered',
                'newly_restarted',
                'newly_transferred',
                'newly_re_challenged',
                'overdue',
                'max_dispensing',
            ];

            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                const matchesPrefix = prefixes.some((prefix) => key.startsWith(prefix));
                if (matchesPrefix) {
                    localStorage.removeItem(key);
                    i--;
                }
            }

            if (item === null || !item) {
                item = this.chartMenuItems[0].value;
                this.chartMenu = item;
            }
            if (item !== 'custom') {
                const period = { period: item };
                this.selectedPeriodValues = period;
                this.fetchReportsChartData(period);
                this.clearPeriod();
            }
            if (item === 'custom') {
                this.customPeriodDialog = true;
            }
        },
        closePeriodDialog() {
            let dates = {
                start_date: null,
                end_date: null,
            };
            if (
                moment(this.customPeriodDates[0]).isAfter(moment(this.customPeriodDates[1])) ||
                this.customPeriodDates[0] === this.customPeriodDates[1]
            ) {
                dates.start_date = this.customPeriodDates[1];
                dates.end_date = this.customPeriodDates[0];
            }
            if (moment(this.customPeriodDates[1]).isAfter(moment(this.customPeriodDates[0]))) {
                dates.start_date = this.customPeriodDates[0];
                dates.end_date = this.customPeriodDates[1];
            }
            const period = {
                period: 'custom',
                ...dates,
            };
            this.$store.dispatch('reports/fetchReportsChartData', {
                period: 'custom',
                ...dates,
            });
            this.selectedPeriodValues = period;
        },
        selectedText(value) {
            let date = value;
            if (value.length === 1) {
                date = moment(value[0]).format(this.$root.dateFormat);
            }
            if (value.length === 2) {
                date = `${moment(value[0]).format(this.$root.dateFormat)} - ${moment(value[1]).format(
                    this.$root.dateFormat
                )}`;
            }
            return `<div class="selected-date">
                <div class="date-selected">${date}</div>
                <div class="date-hint">${t('default::filter.date.range.hint')}</div>
            </div>`;
        },
    },
};
</script>
